// extracted by mini-css-extract-plugin
module.exports = {"registration-button":"_3KNp0","registrationButton":"_3KNp0","disabled":"_3Ieju","link":"_1DgEQ"};